<template>
	<div id="stationChange">
		<div class="hom_station_wrap">
			<div 
			class="hom_station"
			v-for="(station, idx) in cityStations"
			:class="{'d-none': idx >0}"
			:key="idx">
				<h2>{{ station.name }}</h2>
				
				<div class="homst_btminfo">
					<div 
					class="homst_b_item"
					v-for="( info, idx ) in station.show_data"
					:key="idx">
						<h3>{{ info.title }}</h3>
						<i>{{ info.unit }}</i>
						<span>{{ info.numb }}</span>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'stationChange',
	props: {
		cityStations: Array
	},
	methods: {
		
	}
}
</script>
<style>
.d-none{
	display: none;
}
.h1, .h2, .h3, h1, h2, h3{
	margin-top: 0px !important;
}
</style>